import React from 'react'
import { Switch } from 'react-router-dom'
import Route from '../utils/Route'
import { getReportRoutes } from '@/report-app/route-config'

const routes = getReportRoutes()

export default () => {
  return <Switch>
    {routes.map((route, i) => <Route {...route} key={i} />)}
  </Switch>
}



// WEBPACK FOOTER //
// ./src/report-app/routes.js